<template>
<div class="p-4">
  <Form role="form"  @submit="handleUpdate">
      <div class="row">
        <div class="col-md-12">
          <div class="input-group input-group-static mb-4">
            <label>Ansagetext</label>
            <textarea
      class="form-control"
      v-model="vbot.ansagetext"
      name="ansagetext"
      id="ansagetext"
      rows="2"  
    ></textarea>
            <ErrorMessage name="ansagetext" class="text-danger" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="input-group input-group-static mb-4">
            <label>Prompt</label>
            <textarea
      class="form-control"
      v-model="vbot.prompt"
      name="prompt"
      id="prompt"
      rows="8"  
    ></textarea>
    <ErrorMessage name="prompt" class="text-danger" />
          </div>
        </div>
      </div>
<Field
            type="hidden"
            class="form-control"
            v-model="vbot.id"
            name="id"
            id="id"
          />

          <div class="button-row d-flex justify-content-end mt-4">
            <button class="btn btn-sm btn-dark">
             Update Phonebot
            </button>
          </div>
         
        </Form>
       
</div>
  
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import showSwal from "@/mixins/showSwal";

export default {
  name: "Info6",
  
  components: {
    Form,
    Field,
    ErrorMessage
  },
  data() {
    return {
      vbot: {      
        // Initialize other properties as needed
      },
    };
  },
  methods: {
    async handleUpdate() {
      try {
        console.log('Updating vbot:', this.vbot);
        await this.$store.dispatch('vbot/updateVbotByGuest', this.vbot);
        showSwal.methods.showSwal({
          type: "success",
          message: "Phonebot Updated Successfully",
          width: 500,
          timer: 160000,
          showConfirmButton: true
        });
        this.$router.push({ name: 'vbotsForGuest' });
      } catch (error) {
        console.error('Phonebot error:', error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Error In Updating Phonebot!",
          width: 500
        });
      }
    },
  },
   
  async mounted() {
    const licenseKey = this.$route.params.license_Key;

    try {
      const vbots = await this.$store.dispatch('vbot/getVbotByIdForGuest', licenseKey);
      this.vbot = vbots.data;
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  }
};
</script>